import React from 'react';
import { Select, InputNumber } from 'antd';
import { Label } from '../../../../../common/Label/Label';
import styles from '../../Layout/AnalyticsLayout.module.scss';
import { IBestDataset, IPlotVariable } from '../../../../../../types/analytics';
import { monthOptions } from '../../../../ResultPanel/Plot/MonthOptions';

interface RosePlotAdditionalControlsProps {
  datasets: IBestDataset[];
  directions: IPlotVariable[] | null;
  direction: IPlotVariable | null;
  categories: string[];
  directionalDataset: string | null;
  month: number;
  onMonthChange: (value: number) => void;
  onDirectionalDatasetChange: (active: string) => void;
  onDirectionChange: (directionIndex: number) => void;
  directionNo: number;
  degreeIntervals: number[];
  onChangeDirectionNo: (value: number) => void;
  legendInterval: number;
  onChangeIntervalNo: (value: number | null) => void;
  isLoading?: boolean;
  hasError?: boolean;
}

export const RosePlotAdditionalControls = ({
  directions,
  direction,
  datasets,
  categories,
  directionalDataset,
  month,
  onMonthChange,
  onDirectionalDatasetChange,
  onDirectionChange,
  directionNo,
  degreeIntervals,
  onChangeDirectionNo,
  legendInterval,
  onChangeIntervalNo,
  isLoading = false,
  hasError = false,
}: RosePlotAdditionalControlsProps) => {
  return (
    <div className={styles.additionalControlsContainer}>
      <div className={styles.controlItem}>
        <Label label='Directional Dataset'>
          <Select
            id='Analytics-RosePlot-DirectioDataset_Input'
            value={directionalDataset}
            style={{ width: '100%' }}
            onChange={onDirectionalDatasetChange}
            disabled={isLoading || hasError}
          >
            {categories.map((category: string) => (
              <Select.OptGroup key={category} label={category}>
                {datasets
                  .filter((item) => item.label === category)
                  .map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.value}
                    </Select.Option>
                  ))}
              </Select.OptGroup>
            ))}
          </Select>
        </Label>
      </div>

      <div className={styles.controlItem}>
        <Label label='Directional Variable'>
          <Select
            id='Analytics-RosePlot-Direction_Input'
            value={direction ? direction.Index : undefined}
            style={{ width: '100%' }}
            onChange={onDirectionChange}
            disabled={isLoading || hasError}
          >
            {directions?.map((item) => (
              <Select.Option key={item.Index} value={item.Index}>
                {item.Name}
              </Select.Option>
            ))}
          </Select>
        </Label>
      </div>

      <div className={styles.controlItem}>
        <Label label='Directional No. Intervals'>
          <Select
            id='Analytics-RosePlot-NumDirections_Input'
            value={directionNo}
            style={{ width: '100%' }}
            onChange={onChangeDirectionNo}
            disabled={isLoading || hasError}
          >
            {degreeIntervals.map((interval) => (
              <Select.Option key={interval} value={interval}>
                {interval}
              </Select.Option>
            ))}
          </Select>
        </Label>
      </div>

      <div className={styles.controlItem}>
        <Label label='Magnitude Interval'>
          <InputNumber
            id='Analytics-RosePlot-LegendInterval_Input'
            value={legendInterval}
            precision={2}
            min={0.01}
            onChange={onChangeIntervalNo}
            disabled={isLoading || hasError}
            style={{ width: '100%' }}
          />
        </Label>
      </div>

      <div className={styles.controlItem}>
        <Label label='Month'>
          <Select
            id='Analytics-RosePlot-Month_Input'
            value={month}
            style={{ width: '100%' }}
            onChange={(active) => onMonthChange(active)}
            disabled={isLoading || hasError}
          >
            {monthOptions.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Label>
      </div>
    </div>
  );
};

export type { RosePlotAdditionalControlsProps };
